import React, { useContext } from 'react';
import styled from 'styled-components';
import { startOfDay } from 'date-fns';
import { Text, DatePicker, Form } from 'components';
import { useBreakpoint } from 'hooks';
import { Divider, SectionContainer, StyledIcon } from './StyledComponents';
import FormContext from '../FormContext';
import { ERROR_MESSAGES } from '../constants';
import { getDate } from './helpers';

const VacationDates = () => {
  const today = startOfDay(new Date());

  const {
    frontDeskValidState,
    userState,
    setUserState,
    userStateDirty,
    setUserStateDirty,
  } = useContext(FormContext);

  const updateDate = (field: 'to' | 'from', date: Date) => {
    setUserState(prev => ({
      ...prev,
      frontEndInstructions: {
        ...prev.frontEndInstructions,
        vacationDates: {
          ...prev.frontEndInstructions.vacationDates,
          [field]: date,
        },
      },
    }));
  };

  const updateDirtyState = (field: 'to' | 'from') => {
    setUserStateDirty(prev => ({
      ...prev,
      frontEndInstructions: {
        ...prev.frontEndInstructions,
        vacationDates: {
          ...prev.frontEndInstructions.vacationDates,
          [field]: true,
        },
      },
    }));
  };

  const displayStartTimeError =
    userStateDirty.frontEndInstructions.vacationDates.from &&
    !frontDeskValidState.vacationDates.from;

  const displayExpiryTimeError =
    userStateDirty.frontEndInstructions.vacationDates.to &&
    !frontDeskValidState.vacationDates.to;

  const toDate = getDate(userState.frontEndInstructions?.vacationDates?.to);
  const fromDate = getDate(userState.frontEndInstructions?.vacationDates?.from);
  const { md } = useBreakpoint();
  return (
    <StyledSectionContainer>
      <Form.Item
        validateStatus={displayStartTimeError ? 'error' : undefined}
        help={displayStartTimeError ? ERROR_MESSAGES.genericDate : undefined}
      >
        <DatePicker
          label={<Text>Starts</Text>}
          value={getDate(fromDate)}
          onChange={value => updateDate('from', value)}
          disabledDate={date => {
            if (toDate && toDate > today) {
              return !(date > today && date < toDate);
            }
            return today > date;
          }}
          format="MMM D, YYYY"
          placeholder={md ? 'Select date' : 'Select'}
          suffixIcon={<StyledIcon type="calendar" width={12} />}
          onBlur={() => updateDirtyState('from')}
          showNow={false}
        />
      </Form.Item>
      <Form.Item
        validateStatus={displayExpiryTimeError ? 'error' : undefined}
        help={displayExpiryTimeError ? ERROR_MESSAGES.genericDate : undefined}
      >
        <DatePicker
          label={<Text>Ends</Text>}
          value={getDate(toDate)}
          disabledDate={date => {
            if (fromDate) return date < fromDate;
            return today > date;
          }}
          onChange={value => updateDate('to', value)}
          format="MMM D, YYYY"
          placeholder={md ? 'Select date' : 'Select'}
          suffixIcon={<StyledIcon type="calendar" width={12} />}
          onBlur={() => updateDirtyState('to')}
          showNow={false}
        />
      </Form.Item>

      <Divider />
    </StyledSectionContainer>
  );
};

export default VacationDates;

const StyledSectionContainer = styled(SectionContainer)`
  padding-top: 24px;
`;
